import { z } from 'zod';

export const all = async (params: object): Promise<DocumentClass[]> => {
	let queryString = '';
	if (params) {
		const paramsAsString = JSON.stringify(params)
			.replace(/:/g, '=')
			.replace(/,/g, '&')
			.replace(/[{}"]/g, '');

		const searchParams = new URLSearchParams(paramsAsString);
		queryString = `?${searchParams.toString()}`;
	}

	const response = await fetch(`/DocumentClass${queryString}`);

	return await response.json();
};

export const add = async (documentClass: DocumentClass): Promise<boolean> => {
	const res = await fetch(`/DocumentClass`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(documentClass),
	});
	return res.ok;
};

export const update = async (
	documentClass: DocumentClass,
): Promise<boolean> => {
	const res = await fetch(`/DocumentClass`, {
		method: 'PATCH',
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(documentClass),
	});
	return res.ok;
};

export const DocumentClassSchema = z.object({
	id: z.number().nullable(),
	name: z.string().nonempty({ message: 'A document class name is required.' }),
	slug: z.string().nullable(),
	deletedOn: z.date().nullable(),
});

export type DocumentClass = z.infer<typeof DocumentClassSchema>;
